/*
 * Every page renders inside <Screen>. It owns the Trapezium ready marker:
 * once mounted it flags the <main> as ready, titles the document, records the
 * visit, scrolls to the top and announces `trapezium:screen-ready`. An optional
 * `state` is the whole screen's own post-condition (e.g. Home's build-in).
 */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useVisited } from './useVisited';

export default function Screen({ id, title, className, state, children }) {
  const { pathname } = useLocation();
  const { markVisited } = useVisited();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    document.title = `${title} · NirogGyan`;
    markVisited(pathname);
    if (typeof window.scrollTo === 'function') window.scrollTo(0, 0);
    setReady(true);
  }, [title, pathname, markVisited]);

  useEffect(() => {
    if (!ready) return;
    window.dispatchEvent(
      new CustomEvent('trapezium:screen-ready', { detail: { screen: id, route: pathname } }),
    );
  }, [ready, id, pathname]);

  return (
    <main
      id="main"
      tabIndex={-1}
      className={className ? `screen ${className}` : 'screen'}
      data-trapezium-screen={id}
      data-trapezium-ready={ready ? 'true' : 'false'}
      data-trapezium-state={state}
    >
      {children}
    </main>
  );
}
